import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import * as Quotes from '../slices/quotesSlice';
import * as Forms from '../slices/formsSlice';
import { store, useAppDispatch } from '../slices/index';
import { AnyAction } from 'redux';
import NavBar from './navbar';
import NavMenu from './navmenu';
import icon_quote from '../assets/Quote_White.svg';
import leading_the_way from '../assets/Leading_The_Way_Conveyancing.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';

const LoadQuotes = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const newQuote = () => {
		const removequoteform = () => new Promise((resolve) => resolve(dispatch((Forms.removeFormWithId("QF")) as unknown as AnyAction)));
		const removeinstructionform = () => new Promise((resolve) => resolve(dispatch((Forms.removeFormWithId("IF")) as unknown as AnyAction)));
		const selquote = () => new Promise((resolve) => resolve(dispatch((Quotes.selectQuote("")) as unknown as AnyAction)));
		removequoteform().then(() => removeinstructionform()).then(() => selquote()).then(() => navigate('/quote'));
	}

	useEffect(() => {
		dispatch(Quotes.getQuoteList(({ id: store.getState().user.id })) as unknown as AnyAction).then(() => {
			navigate('/quotes');
		})
	}, []);

	return (
		<div className='Home'>
			<div style={{ position: 'absolute', top: 96, left: 0, right: 0, bottom: 80 }}>
				<div className='OrangeBand'>
					<div style={{ marginLeft: 'calc(10% + 144px)', marginRight: '10%', width: 'calc(80% - 144px)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<img style={{ width: 96, height: 96, marginRight: 8 }} src={icon_quote} alt='Quote-Icon' />
							<div style={{ marginLeft: 24 }}>
								<div style={{ display: 'flex', alignItems: 'center' }}>
									<div style={{ fontFamily: 'OpenSans-Bold', fontSize: 36, marginBottom: 12, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Your Quote List</div>
									<FontAwesomeIcon className='fa-spin' style={{ fontSize: 28, marginLeft: 16, marginRight: 8 }} icon={faSync} />
								</div>
							</div>
						</div>
						<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', padding: 8, fontSize: 20, border: '4px solid white' }} onClick={() => newQuote()}>
							<div style={{ display: 'flex' }}>
								<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', marginLeft: 24 }}>Get a Quote</div>
							</div>
							<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className='mainFooter'>
				<div style={{ marginLeft: '10%', marginRight: '10%', width: '80%', marginTop: 18 }}>
					<img style={{ height: 28 }} src={leading_the_way} alt='LeadingTheWay-Banner' />
				</div>
			</div>
			<div className='loginFooter'></div>
			<NavMenu />
			<NavBar />
		</div>
	);
}

export default LoadQuotes;